<template>
  <div class="claim-template">
    <PageHeaderCount
      moduleType="claim"
      :dataLoading="dataLoading"
      :statusList="statusList2"
      allkey="all_claims"
      countkey="claim_status_count"
    />
    <ListingTemplate :customClass="'claim-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-col cols="4" class="pt-0 my-auto">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-col>
              <v-col cols="8" class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('lead:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in bulkActions"
                        link
                        @click="bulkAction(item.action)"
                        :key="index"
                      >
                        <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                          <v-icon class="icon-default-blue">{{
                            item.icon
                          }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title
                          class="font-weight-500 font-size-14"
                          >{{ item.title }}</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" class="py-0 col-lg-6">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :disabled="dataLoading"
                    :items="statusList2"
                    v-model="status"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_claims
                          }}</template>
                          <template v-else>{{
                            item.claim_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-col>

              <v-col
                cols="8"
                class="py-0 justify-flex-end d-flex margin-auto col-lg-6 all-project-btn-right"
              >
                <template v-if="getPermission('claim:create')">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    :to="getDefaultRoute('claim.create')"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>

                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                  content-class="white-background"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button btn-tab-hide"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    @change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          :value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          hide-details
                          class="pt-2 mt-0"
                          @change="updateVisible()"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <PageTips v-if="false" module="claim"></PageTips>
              </v-col>
            </template>
          </template>
        </ListingHeader>

        <!-- Search Criteria -->
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Claim"
          :basicSearchFields="searchFields"
          :result="totalRows"
          :allowedSearchFields="searchableArray"
          :searchEnabled="searchEnabled"
        />

        <!-- Table Section -->
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <!-- Table Header -->
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.field"
                      class="simple-table-th"
                    >
                      <!-- Sortable Headers -->
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          @click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : null
                          "
                        >
                          {{ cols.headerName }}
                          <template v-if="cols.sort">
                            <v-icon
                              class="simple-table-sort"
                              v-if="cols.sort == 'asc'"
                              small
                              right
                              color="cyan"
                            >
                              mdi-sort-ascending
                            </v-icon>
                            <v-icon
                              class="simple-table-sort"
                              v-if="cols.sort == 'desc'"
                              small
                              right
                              color="cyan"
                            >
                              mdi-sort-descending
                            </v-icon>
                          </template>
                        </div>
                        <!-- Non-sortable Headers -->
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>

            <!-- Table Body -->
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!dataLoading">
                  <template v-if="rowData && rowData.length > 0">
                    <tr
                      v-for="(data, index) in rowData"
                      :key="data.id || index"
                    >
                      <template v-for="cols in customThead">
                        <td
                          v-if="cols.visible"
                          :key="cols.field"
                          :class="{
                            'simple-table-td': !cols.checkbox,
                            'cursor-pointer': Number(cols.checkbox) == 0,
                          }"
                          :style="{ 'max-width': cols.width }"
                          v-on:click="rowClicked(data)"
                        >
                          <template
                            v-if="cols.checkbox && Number(cols.checkbox) == 1"
                          >
                            <v-checkbox
                              @click.stop=""
                              dense
                              v-model="selectedRows"
                              v-bind:value="data.id"
                              color="cyan"
                              class="hide-margin"
                              hide-details
                              :disabled="data.status == 2 || data.status == 3"
                            ></v-checkbox>
                          </template>
                          <!-- Barcode Column -->

                          <template v-if="cols.field === 'barcode'">
                            <Barcode
                              :barcode="data.claim_barcode || data.barcode"
                            ></Barcode>
                          </template>

                          <!-- Amount Column -->
                          <template v-else-if="cols.field === 'amount'">
                            <v-chip small class="py-0" color="green" label>
                              <span class="text-white">
                                <b
                                  >{{ data.currency_name }} {{ data.amount }}</b
                                >
                              </span>
                            </v-chip>
                          </template>
                          <!-- employee Column -->
                          <template v-else-if="cols.field === 'employee'">
                            <div
                              v-if="data.employee"
                              class="d-flex align-center"
                              style="width: 150px"
                            >
                              <v-avatar
                                size="30"
                                color="blue lighten-4"
                                class="mr-2"
                              >
                                <span
                                  class="text-uppercase blue--text font-size-16 fw-600"
                                >
                                  {{ getFirstLetters(data.employee) }}
                                </span>
                              </v-avatar>
                              <b>{{ data.employee }}</b>
                            </div>
                            <em v-else class="text-muted">No employee</em>
                          </template>
                          <template v-else-if="cols.field === 'designation'">
                            <!-- {{ data }}                       -->
                            <div class="customer-listing-customer">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <template v-if="data.designation">
                                  <v-chip label small outlined color="green">
                                    {{ data.designation }}
                                  </v-chip></template
                                >
                                <em v-else class="text-muted"
                                  >No designation</em
                                >
                              </p>
                            </div>
                          </template>
                          <!-- Type Column -->
                          <template v-else-if="cols.field == 'type'">
                            <div class="customer-listing-customer">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <template v-if="data.expense_category">
                                  <div @click.stop="">
                                    <template v-if="data.expense_category == 3">
                                      <div class="d-flex flex-column mb-1">
                                        <!-- Visit -->
                                        <router-link
                                          v-if="data.barcode"
                                          :to="{
                                            name: 'admin.visit.detail',
                                            params: { id: data.visit || 0 },
                                          }"
                                          style="text-decoration: none"
                                        >
                                          <v-chip
                                            small
                                            color="blue"
                                            label
                                            outlined
                                            class="cursor-pointer mb-1"
                                          >
                                            {{ data.barcode }}
                                          </v-chip>
                                        </router-link>

                                        <!-- Project -->
                                        <router-link
                                          v-if="data.project_barcode"
                                          :to="{
                                            name: 'admin.project.detail',
                                            params: { id: data.project || 0 },
                                          }"
                                          style="text-decoration: none"
                                        >
                                          <v-chip
                                            small
                                            color="green"
                                            label
                                            outlined
                                            class="cursor-pointer mb-1"
                                          >
                                            {{ data.project_barcode }}
                                          </v-chip>
                                        </router-link>

                                        <!-- Quotation -->
                                        <router-link
                                          v-if="data.quotation_barcode"
                                          :to="{
                                            name: 'admin.quotation.detail',
                                            params: { id: data.quotation || 0 },
                                          }"
                                          style="text-decoration: none"
                                        >
                                          <v-chip
                                            small
                                            color="orange"
                                            label
                                            outlined
                                            class="cursor-pointer mb-1"
                                          >
                                            {{ data.quotation_barcode }}
                                          </v-chip>
                                        </router-link>
                                      </div>
                                    </template>
                                    <!-- <template
                                     v-if="data.expense_category == 4"
                                    >
                                      <router-link
                                        :to="{
                                              name: 'admin.lead.detail',
                                              params: {
                                                id: data ? data.lead : 0
                                              }
                                            }"
                                        style="text-decoration: none"
                                      >
                                        <v-chip
                                          small
                                          color="green"
                                          label
                                          outlined
                                          class="cursor-pointer"
                                        >
                                          {{ data.barcode }}
                                        </v-chip>
                                      </router-link>
                                      <router-link
                                          v-if="data.quotation_barcode"
                                          :to="{
                                            name: 'admin.quotation.detail',
                                            params: { id: data.quotation || 0 }
                                          }"
                                          style="text-decoration: none"
                                        >
                                          <v-chip small color="orange" label outlined class="cursor-pointer">
                                            {{ data.quotation_barcode }}
                                          </v-chip>
                                        </router-link>
                                    </template> -->
                                    <template v-if="data.expense_category == 4">
                                      <!-- Lead -->
                                      <router-link
                                        v-if="data.lead && data.lead != 0"
                                        :to="{
                                          name: 'admin.lead.detail',
                                          params: { id: data.lead },
                                        }"
                                        style="text-decoration: none"
                                      >
                                        <v-chip
                                          small
                                          color="green"
                                          label
                                          outlined
                                          class="cursor-pointer"
                                        >
                                          {{ data.barcode }}
                                        </v-chip>
                                      </router-link>

                                      <!-- Visit -->
                                      <router-link
                                        v-if="data.visit && data.visit != 0"
                                        :to="{
                                          name: 'admin.visit.detail',
                                          params: { id: data.visit },
                                        }"
                                        style="text-decoration: none"
                                      >
                                        <v-chip
                                          small
                                          color="blue"
                                          label
                                          outlined
                                          class="cursor-pointer"
                                        >
                                          {{ data.visit_barcode }}
                                        </v-chip>
                                      </router-link>
                                    </template>
                                  </div>
                                </template>
                                <em v-else class="text-muted">No Type</em>
                              </p>
                            </div>
                          </template>

                          <!-- Status Column -->
                          <template v-else-if="cols.field == 'status'">
                            <div class="claim-listing-status">
                              <CustomStatus
                                v-if="false"
                                small
                                :status="data.status"
                              ></CustomStatus>
                              <v-chip
                                label
                                small
                                v-if="data.status == 1"
                                color="orange"
                                text-color="white"
                                >Pending</v-chip
                              >
                              <v-chip
                                label
                                small
                                v-else-if="data.status == 2"
                                color="green"
                                text-color="white"
                                >Approved</v-chip
                              >
                              <v-chip
                                label
                                small
                                v-else-if="data.status == 3"
                                color="red"
                                text-color="white"
                                >Rejected</v-chip
                              >
                              <span v-else class="text-muted">No Status</span>
                              <div>
                                <template
                                  v-if="
                                    data.status == 2 &&
                                    data.reimbursed_status ==
                                      'Reimbursement Pending'
                                  "
                                >
                                  <v-chip
                                    class="mt-1"
                                    label
                                    small
                                    color="orange lighten-4"
                                    text-color="orange"
                                    >Reimbursement Pending</v-chip
                                  >
                                </template>
                                <template
                                  v-if="
                                    data.status == 2 &&
                                    data.reimbursed_status == 'Reimbursed'
                                  "
                                >
                                  <v-chip
                                    class="mt-1"
                                    label
                                    small
                                    color="green lighten-4"
                                    text-color="green"
                                    >Reimbursed</v-chip
                                  >
                                </template>
                              </div>
                            </div>
                          </template>

                          <!-- Expense Date Column -->
                          <template v-else-if="cols.field === 'expense_date'">
                            <v-chip
                              v-if="data.expense_date"
                              class="mx-2 mb-0 custom-grey-border d-table-caption"
                              color="cyan darken-1"
                              outlined
                              small
                              label
                            >
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{ formatDate(data.expense_date) }}
                              </p>
                            </v-chip>

                            <em v-else class="text-muted">No date</em>
                          </template>

                          <!-- Added At Column -->
                          <template v-else-if="cols.field == 'added_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.added_by)"
                              :data="data"
                            >
                              <template v-slot:first_letters>
                                {{
                                  getFirstLetters(data.added_by?.display_name)
                                }}
                              </template>
                              <template v-slot:display_name>
                                {{ data.added_by?.display_name }}
                              </template>
                              <template v-slot:date_time>
                                {{ data.added_at_human }}
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDate(data.added_at) }}
                                {{ formatTime(data.added_at) }}
                              </template>
                            </TableActivity>
                          </template>

                          <!-- Company Name Column -->
                          <template v-else-if="cols.field == 'company_name'">
                            <div class="customer-listing-customer">
                              <p class="m-0 align-top line-climp-content">
                                <b><v-icon small>mdi-domain</v-icon></b>
                                <template
                                  v-if="data && data.customer_company_name"
                                >
                                  <b
                                    class="fw-500 ms-1"
                                    style="font-weight: 700 !important"
                                  >
                                    {{ data.customer_company_name }}</b
                                  >
                                </template>
                                <em v-else class="text-muted">
                                  no company name</em
                                >
                              </p>
                            </div>
                          </template>

                          <!-- Title Column -->
                          <template v-else-if="cols.field == 'title'">
                            <div class="customer-listing-customer">
                              <v-tooltip
                                top
                                max-width="400"
                                content-class="custom-top-tooltip"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <p
                                    class="m-0 align-top line-climp-content"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <template v-if="data && data.title">
                                      {{ data.title }}
                                    </template>

                                    <em v-else class="text-muted">no title</em>
                                  </p>
                                </template>

                                <span>
                                  {{ (data && data.title) || "no title" }}
                                </span>
                              </v-tooltip>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'category'">
                            <div class="customer-listing-customer">
                              <p class="m-0 align-top">
                                <template
                                  v-if="data && data.expense_category_name"
                                >
                                  <v-chip
                                    label
                                    outlined
                                    small
                                    :color="data.expense_category_color"
                                    class="d-flex align-center justify-center"
                                  >
                                    {{ data.expense_category_name }}
                                  </v-chip>
                                </template>
                                <em v-else class="text-muted">no category</em>
                              </p>
                            </div>
                          </template>

                          <template v-else-if="cols.field === 'payment'">
                            <v-chip
                              small
                              class="py-0 d-inline-flex align-center justify-center"
                              outlined
                              color="green"
                              label
                            >
                              <b v-if="Number(data.payment_mode) == 1">
                                <v-icon small class="mr-1"
                                  >mdi-credit-card-outline</v-icon
                                >
                                Credit Card
                              </b>

                              <b v-else-if="Number(data.payment_mode) == 2">
                                <v-icon small class="mr-1"
                                  >mdi-credit-card-outline</v-icon
                                >
                                Debit Card
                              </b>

                              <b v-else-if="Number(data.payment_mode) == 3">
                                <v-icon small class="mr-1">mdi-bank</v-icon>
                                Bank Transfer
                              </b>

                              <b v-else-if="Number(data.payment_mode) == 4">
                                <v-icon small class="mr-1">mdi-receipt</v-icon>
                                Cheque
                              </b>

                              <b v-else-if="Number(data.payment_mode) == 5">
                                <v-icon small class="mr-1">mdi-cash</v-icon>
                                Cash
                              </b>
                            </v-chip>
                          </template>
                          <template v-else-if="cols.field == 'description'">
                            <div class="customer-listing-customer">
                              <p class="m-0 align-top line-climp-content">
                                <template v-if="data && data.note">
                                  {{ data.note }}
                                </template>
                                <em v-else class="text-muted"
                                  >no description</em
                                >
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'vendor'">
                            <div class="customer-listing-customer">
                              <p class="m-0 align-top line-climp-content">
                                <template v-if="data && data.vendor_name">
                                  {{ data.vendor_name }}
                                </template>
                                <em v-else class="text-muted">no vendor</em>
                              </p>
                            </div>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <!-- Empty State -->
                  <tr v-else>
                    <td :colspan="15" class="py-4">
                      <p
                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                      >
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image"
                        />
                        Uhh... There are no claim at the moment..
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>

        <!-- Footer with Pagination -->
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom || 0"
          :showingTo="showingTo || 0"
          :totalRows="parseInt(totalRows) || 0"
          :currentPage="parseInt(currentPage) || 1"
          :totalPages="parseInt(totalPages) || 1"
        />
        <v-navigation-drawer
          v-model="searchDialog"
          app
          bottom
          temporary
          stateless
          right
          :width="600"
          style="z-index: 500"
        >
          <v-card
            text
            elevation="0"
            class="d-flex flex-column h-100 custom-field"
          >
            <!-- Drawer Title -->
            <v-card-title
              class="headline dialog-custom-header text-uppercase custom-border-bottom custom-header-blue-text white-background"
            >
              <span style="font-size: 18px"> Filter Claims </span>
              <v-spacer></v-spacer>
              <v-btn icon small @click="searchDialog = false">
                <v-icon size="30">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <!-- Drawer Content -->
            <v-card-text class="flex-grow-1 px-3">
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll custom-box-top-inner-shado"
                style="height: calc(100vh - 145px); position: relative"
              >
                <v-container fluid class="pt-0 custom-search-filter">
                  <v-row>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Date Range</label
                      >
                      <DateRangePicker
                        v-model="dates"
                        placeholder="Select Claim Date Range"
                      />
                    </v-col>

                    <v-col md="12" v-if="false">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Status</label
                      >
                      <v-select
                        :menu-props="{ offsetY: true }"
                        :items="statusListArr"
                        v-model="listingSearch['expense_category']"
                        placeholder="Filter Status"
                        dense
                        filled
                        hide-details
                        solo
                        flat
                        item-color="cyan"
                        :clearable="true"
                      >
                      </v-select>
                    </v-col>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Category</label
                      >
                      <v-select
                        :menu-props="{ offsetY: true }"
                        :items="categoryList"
                        v-model="listingSearch['expense_category']"
                        placeholder="Filter Category"
                        dense
                        filled
                        hide-details
                        solo
                        flat
                        item-color="cyan"
                        :clearable="true"
                        item-text="text"
                        item-value="text"
                      >
                      </v-select>
                    </v-col>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Employee</label
                      >
                      <v-select
                        :menu-props="{ offsetY: true }"
                        :items="employeeList"
                        v-model="listingSearch['employee']"
                        placeholder="Filter Employee"
                        dense
                        filled
                        hide-details
                        solo
                        flat
                        item-color="cyan"
                        :clearable="true"
                        item-text="text"
                        item-value="text"
                      >
                      </v-select>
                    </v-col>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Payment Mode</label
                      >
                      <v-select
                        :menu-props="{ offsetY: true }"
                        :items="paymentModeList"
                        v-model="listingSearch['payment_mode']"
                        placeholder="Payment Mode"
                        dense
                        filled
                        hide-details
                        solo
                        flat
                        item-color="cyan"
                        :clearable="true"
                        item-text="text"
                        item-value="text"
                      >
                      </v-select>
                    </v-col>

                    <template v-for="(field, index) in searchableArray">
                      <v-col
                        md="12"
                        :key="index"
                        v-if="
                          field != 'dates' &&
                          field != 'customer' &&
                          field != 'currency' &&
                          field != 'title' &&
                          field != 'amount' &&
                          field != 'company_name' &&
                          field != 'expense_category' &&
                          field != 'employee' &&
                          field != 'customer_lead' &&
                          field != 'payment_mode'
                        "
                      >
                        <label
                          class="v-label font-weight-500 font-size-13 text-capitalize"
                          >{{ getFilterLabel(field, "Claim") }}</label
                        >
                        <v-text-field
                          v-model.trim="listingSearch[field]"
                          dense
                          filled
                          hide-details
                          :placeholder="getFilterLabel(field, 'Claim')"
                          solo
                          flat
                          clearable
                          @keydown.enter="filterRows"
                          color="cyan"
                        ></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </perfect-scrollbar>
            </v-card-text>
            <!-- Drawer Actions -->
            <v-divider class="my-0"></v-divider>
            <v-card-actions class="d-flex justify-en px-4 pb-4">
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red white--text"
                v-on:click="removeFilters('clear')"
              >
                <v-icon left>mdi-close</v-icon>
                <span>Clear Filter</span>
              </v-btn>
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                v-on:click="filterRows"
              >
                <v-icon left>mdi-magnify</v-icon>
                <span>Apply Filter</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
        <!-- Search Dialog -->
        <Dialog :commonDialog="searchDialog" v-if="false">
          <template v-slot:title>Filter Claims</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="6">
                    <DateRangePicker
                      v-model="dates"
                      placeholder="Select Claim Date From"
                    />
                  </v-col>
                  <v-col md="6">
                    <DateRangePicker
                      v-model="expenseDates"
                      placeholder="Select Date To"
                    />
                  </v-col>
                  <template v-for="(field, index) in searchableArray">
                    <v-col md="6" :key="index" v-if="field != 'dates'">
                      <v-text-field
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :placeholder="getFilterLabel(field, 'Claim')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
        <!-- Accept Modal -->
        <Dialog
          v-if="acceptDialog"
          :commonDialog="acceptDialog"
          :dialogWidth="600"
        >
          <template v-slot:title>Confirmation</template>
          <template v-slot:body>
            <v-form
              ref="acceptForm"
              v-model.trim="acceptFormValid"
              lazy-validation
            >
              <v-container class="px-10" fluid>
                <p class="font-weight-600 font-size-19">
                  Are you sure, you want to
                  <span class="font-weight-700">Mark as Approved</span>?
                </p>

                <v-layout class="my-4">
                  <v-flex>
                    <label class="font-weight-500 font-size-16 required"
                      >Remark</label
                    >
                    <v-textarea
                      v-model="acceptRemark"
                      :rules="[(v) => !!v || 'Remark is required']"
                      auto-grow
                      dense
                      filled
                      color="cyan"
                      placeholder="Remark"
                      solo
                      flat
                      row-height="25"
                      counter="200"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout class="mt-4">
                  <v-flex md12>
                    <label class="font-weight-500 font-size-16"
                      >Attachment</label
                    >
                    <file-upload v-model="acceptAttachments" :maxLimit="5">
                    </file-upload>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="statusLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="closeAcceptModal"
            >
              No! Close
            </v-btn>
            <v-btn
              depressed
              :disabled="!acceptFormValid || statusLoading"
              :loading="statusLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="submitAccept"
            >
              Yes! Continue
            </v-btn>
          </template>
        </Dialog>
        <!-- Reject Modal -->
        <Dialog
          v-if="rejectDialog"
          :commonDialog="rejectDialog"
          :dialogWidth="600"
        >
          <template v-slot:title>Confirmation</template>
          <template v-slot:body>
            <v-form
              ref="rejectForm"
              v-model.trim="rejectFormValid"
              lazy-validation
            >
              <v-container class="px-10" fluid>
                <p class="font-weight-600 font-size-19">
                  Are you sure, you want to
                  <span class="font-weight-700">Mark as Rejected</span>?
                </p>

                <v-layout class="my-4">
                  <v-flex>
                    <label class="font-weight-500 font-size-16 required"
                      >Remark</label
                    >
                    <v-textarea
                      v-model="rejectRemark"
                      :rules="[(v) => !!v || 'Remark is required']"
                      auto-grow
                      dense
                      filled
                      color="cyan"
                      placeholder="Remark"
                      solo
                      flat
                      row-height="25"
                      counter="200"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout class="mt-4">
                  <v-flex md12>
                    <label class="font-weight-500 font-size-16"
                      >Attachment</label
                    >
                    <file-upload v-model="rejectAttachments" :maxLimit="5">
                    </file-upload>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="statusLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="closeRejectModal"
            >
              No! Close
            </v-btn>
            <v-btn
              depressed
              :disabled="!rejectFormValid || statusLoading"
              :loading="statusLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="submitReject"
            >
              Yes! Continue
            </v-btn>
          </template>
        </Dialog>
      </template>
    </ListingTemplate>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import draggable from "vuedraggable";
import Barcode from "@/view/pages/partials/Barcode.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/DialogNew.vue";
import DateRangePicker from "@/view/components/DateRangePicker.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import FileUpload from "@/view/components/app-component/FileInput";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import { PATCH, GET } from "@/core/services/store/request.module";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
import { SuccessEventBus } from "@/core/lib/message.lib";
import moment from "moment";
// import { SearchEventBus } from "@/core/lib/search.lib";
// import { SearchEventBus } from "@/core/lib/search.lib";
export default {
  name: "claim-list",
  mixins: [CommonMixin, ListingMixin],

  components: {
    PageHeaderCount,
    draggable,
    Barcode,
    PageTips,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    DateRangePicker,
    TableActivity,
    CustomStatus,
    FileUpload,
  },

  data() {
    return {
      acceptFormValid: false,
      acceptRemark: "",
      acceptAttachments: [],
      acceptDialog: false,
      rejectFormValid: false,
      rejectDialog: false,
      rejectRemark: null,
      rejectAttachments: [],
      statusLoading: false,
      pageModule: "claim-listing",
      routeAPI: "claims",
      routeName: "claim",
      routeDetailName: "claim.detail",
      status: "all",
      exportLoading: false,
      totalPages: 1,
      dates: [],
      categoryList: [],
      employeeList: [],
      employee: null,
      customer: null,
      customerList: [],
      category: null,
      payment: null,
      dialogStatus: null,
      dialogCategory: null,
      dialogEmployee: null,
      dialogCustomer: null,
      dialogPayment: null,
      isInitializing: true,
      dialogDates: [],

      searchFields: [
        "barcode",
        "title",
        "company_name",
        "amount",
        "currency",
        "vendor_name",
        "payment_mode",
        "engineer",
        "designation",
      ],
      statusList2: [],
      statusListArr: [
        { text: "All Claims", value: "all" },
        { text: "Pending", value: "draft" },
        { text: "Approved", value: "accepted" },
        { text: "Rejected", value: "rejected" },
        { text: "Reimbursed", value: "reimbursed" },
        { text: "Reimbursement Pending", value: "reimbursedpending" },
      ],
      paymentModeList: [],
      rowData2: [],
      customThead: [],
      bulkActions: [
        {
          title: "Mark as Rejected",
          action: "reject",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Approved",
          action: "accept",
          icon: "mdi-check-all",
        },
      ],
      menu: false,

      moreActions: [
        {
          title: "Refresh List",
          action: "refresh_list",
          icon: "mdi-refresh",
        },
      ],
    };
  },

  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param;
        } else {
          this.listingSearch["dates"] = [];
        }
      },
    },
    rowData: {
      handler() {
        this.selectedRows = this.selectedRows.filter((id) => {
          const claim = this.rowData.find((row) => row.id === id);
          return claim && claim.status != 2 && claim.status != 3;
        });
      },
      deep: true,
    },
    // $route(to) {
    //   if (to.name === this.routeName) {
    //     this.selectedRows = [];
    //     this.dates = [];
    //     this.category = null;
    //     this.employee = null;
    //     this.customer = null;
    //     this.listingSearch = {};
    //     this.clearSearch();
    //   }
    // },
    $route: {
      immediate: true,
      handler(route) {
        if (this.isInitializing) return;

        if (route.query.status) {
          this.status = route.query.status;
        }
      },
    },
    category: {
      handler(val) {
        if (this.isInitializing) return;
        if (val) {
          this.listingSearch["expense_category"] = val;
          this.searchEnabled = true;
          this.listingSearch["expense_category_name"] =
            this.getCategoryName(val);
          this.lodash.assign(this.queryParams, {
            expense_category: this.getCategoryName(val),
          });
          this.pushQueryParams();
        } else {
          delete this.listingSearch["expense_category"];
          delete this.listingSearch["expense_category_name"];
          delete this.queryParams["expense_category"];
          if (this.lodash.isEmpty(this.listingSearch)) {
            this.searchEnabled = false;
          }
          this.pushQueryParams();
        }
      },
      //immediate: true,
    },
    payment: {
      handler(val) {
        if (val) {
          if (this.isInitializing) return;
          const name = this.getPaymentName(val);
          this.searchEnabled = true;
          this.listingSearch["payment_mode"] = name;
          this.listingSearch["payment_mode_name"] = name;
          this.lodash.assign(this.queryParams, { payment_mode: name });
          this.pushQueryParams();
        } else {
          delete this.listingSearch["payment_mode"];
          delete this.listingSearch["payment_mode_name"];
          delete this.queryParams["payment_mode"];
          if (this.lodash.isEmpty(this.listingSearch)) {
            this.searchEnabled = false;
          }
        }

        this.pushQueryParams();
      },
      //immediate: true,
    },

    employee: {
      handler(val) {
        if (this.isInitializing) return;
        if (val) {
          this.listingSearch["employee"] = val;
          this.searchEnabled = true;
          this.listingSearch["employee_name"] = this.getEmployeeName(val);
          this.lodash.assign(this.queryParams, {
            employee: this.getEmployeeName(val),
          });
          this.pushQueryParams();
        } else {
          delete this.listingSearch["employee"];
          delete this.listingSearch["employee_name"];
          delete this.queryParams["employee"];
          if (this.lodash.isEmpty(this.listingSearch)) {
            this.searchEnabled = false;
          }
          this.pushQueryParams();
        }
      },
      // immediate: true,
    },
    customer: {
      handler(val) {
        if (this.isInitializing) return;
        if (val) {
          this.listingSearch["customer_lead"] = val;
          this.searchEnabled = true;
          this.lodash.assign(this.queryParams, {
            customer_lead: this.getCustomerName(val),
          });
          this.pushQueryParams();
        } else {
          delete this.listingSearch["customer_lead"];
          delete this.queryParams["customer_lead"];
          if (this.lodash.isEmpty(this.listingSearch)) {
            this.searchEnabled = false;
          }
          this.pushQueryParams();
        }
      },
    },
    searchDialog: {
      handler(val) {
        if (val) {
          this.dialogStatus = this.status;
          this.dialogCategory = this.category;
          this.dialogEmployee = this.employee;
          this.dialogCustomer = this.customer;
          this.dialogPayment = this.payment;
          this.dialogDates = [...this.dates];
        }
      },
    },
  },

  computed: {
    selectedAll: {
      get() {
        const filtered = this.rowData.filter(
          (row) => row.status != 2 && row.status != 3
        );
        return (
          filtered.length > 0 &&
          filtered.every((row) => this.selectedRows.includes(row.id))
        );
      },
      set(value) {
        if (value) {
          this.selectedRows = [
            ...new Set([
              ...this.selectedRows,
              ...this.rowData
                .filter((row) => row.status != 2 && row.status != 3)
                .map((row) => row.id),
            ]),
          ];
        } else {
          this.selectedRows = this.selectedRows.filter(
            (id) =>
              !this.rowData.some(
                (row) => row.id === id && row.status != 2 && row.status != 3
              )
          );
        }
      },
    },
  },

  methods: {
    getStatusList() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "claim/status" })
            .then((response) => {
              const data = (response.data || []).filter(
                (item) => item.value !== "total"
              );

              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    getClaimOptions() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(GET, { url: "claims/options" })
          .then((response) => {
            const data = response.data || {};
            this.categoryList = Array.isArray(data.claim_categories)
              ? data.claim_categories.map((cat) => ({
                  text: String(cat.name),
                  value: String(cat.id),
                }))
              : [];
            this.employeeList = Array.isArray(data.employees)
              ? data.employees.map((emp) => ({
                  text: String(emp.name),
                  value: String(emp.id),
                }))
              : [];
            this.customerList = Array.isArray(data.customers)
              ? data.customers.map((cust) => ({
                  text: String(cust.name),
                  value: String(cust.id),
                }))
              : [];
            this.paymentModeList = Array.isArray(data.payment_modes)
              ? data.payment_modes.map((pay) => ({
                  text: String(pay.name),
                  value: String(pay.id),
                }))
              : [];
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCategoryName(id) {
      const category = this.categoryList.find((cat) => cat.value === id);
      return category ? category.text : "";
    },
    getPaymentName(id) {
      const payment = this.paymentModeList.find((pay) => pay.value === id);
      return payment ? payment.text : "";
    },
    getEmployeeName(id) {
      const employee = this.employeeList.find((emp) => emp.value === id);
      return employee ? employee.text : "";
    },
    getCustomerName(id) {
      const customer = this.customerList.find((cust) => cust.value === id);
      return customer ? customer.text : "";
    },
    getLabelNew(field) {
      const labelMap = {
        barcode: "Claim #",
        payment_mode: "Payment Mode",
        expense_category: "Category",
        employee: "Employee",
        customer_lead: "Customer/Lead",
      };
      return labelMap[field] || this.getFilterLabel(field, "Claim");
    },
    // filterRows() {
    //   this.status = this.dialogStatus;
    //   this.category = this.dialogCategory;
    //   this.employee = this.dialogEmployee;
    //   this.customer = this.dialogCustomer;
    //   this.payment = this.dialogPayment;
    //   this.dates = [...this.dialogDates];
    //   this.getRows();
    //   this.searchDialog = false;
    // },
    removeFilters() {
      this.status = "all";
      this.category = null;
      this.employee = null;
      this.customer = null;
      this.dates = [];
      this.listingSearch = {};
      this.clearSearch();
      this.dialogStatus = null;
      this.dialogCategory = null;
      this.dialogEmployee = null;
      this.dialogCustomer = null;
      this.dialogPayment = null;
      this.dialogDates = [];
    },
    closeAcceptModal() {
      this.acceptDialog = false;
    },
    closeRejectModal() {
      this.rejectDialog = false;
    },
    submitAccept() {
      const _this = this;
      if (_this.$refs.acceptForm.validate()) {
        _this.statusLoading = true;
        const promises = _this.selectedRows.map((id) => {
          return _this.$store.dispatch(PATCH, {
            url: `claims/${id}/status`,
            data: {
              status: "mark_as_accepted",
              remark: _this.acceptRemark,
              attachments: _this.acceptAttachments,
            },
          });
        });
        Promise.all(promises)
          .then(() => {
            _this.closeAcceptModal();
            _this.clearSelections();
            _this.getRows();
            SuccessEventBus.$emit(
              "update:success",
              "Claim approved successfully"
            );
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.statusLoading = false;
          });
      }
    },
    submitReject() {
      const _this = this;
      if (_this.$refs.rejectForm.validate()) {
        _this.statusLoading = true;
        const promises = _this.selectedRows.map((id) => {
          return _this.$store.dispatch(PATCH, {
            url: `claims/${id}/status`,
            data: {
              status: "mark_as_rejected",
              remark: _this.rejectRemark,
              attachments: _this.rejectAttachments,
            },
          });
        });
        Promise.all(promises)
          .then(() => {
            _this.closeRejectModal();
            _this.clearSelections();
            _this.getRows();
            SuccessEventBus.$emit(
              "update:success",
              "Claim rejected successfully"
            );
          })
          .catch((error) => {
            _this.logError(error);
          })
          .finally(() => {
            _this.statusLoading = false;
          });
      }
    },
    bulkAction(action) {
      if (action === "accept") {
        this.acceptDialog = true;
      }

      if (action === "reject") {
        this.rejectDialog = true;
      }
    },
    activeInactive(data) {
      const _this = this;
      const newStatus = data.activated ? 0 : 1;

      _this.$store
        .dispatch(PATCH, {
          url: `claim/${newStatus}/${data.id}`,
        })
        .catch((error) => {
          _this.logError(error);
          data.activated = !data.activated;
        })
        .finally(() => {
          _this.getRows();
        });
    },

    getTypeColor(type) {
      switch (type) {
        case "Visit":
          return "blue";
        case "Opportunity":
          return "green";
        case "Project":
          return "orange";
        default:
          return "grey";
      }
    },

    // ✅ LOCAL DATE FORMATTING METHODS ✅
    /**
     * Format datetime to relative time like "19 min ago", "2 hours ago"
     */
    formatDateTime(dateTime) {
      if (!dateTime) return "-";
      return moment(dateTime).fromNow();
    },

    /**
     * Format date like "16 Oct 2025"
     */
    formatDate(dateTime) {
      if (!dateTime) return "-";
      return moment(dateTime).format("DD MMM YYYY");
    },

    /**
     * Format time like "11:46 AM"
     */
    formatTime(dateTime) {
      if (!dateTime) return "-";
      return moment(dateTime).format("hh:mm A");
    },

    handleApiError(error) {
      console.error("API Error:", error);
      this.dataLoading = false;
      this.rowData = [];
      this.currentPage = 1;

      this.$store.dispatch("showMessage", {
        text:
          error.response?.data?.message ||
          "Error loading data. Please try again.",
        color: "error",
      });
    },
  },

  async created() {
    this.rowData = [];
    this.currentPage = 1;

    this.queryParams = {
      status: this.status || "all",
      page: this.currentPage,
      per_page: parseInt(this.paginationPageSize || 50),
    };

    // this.$nextTick(() => {
    //   this.getRows();
    // });

    this.statusList2 = await this.getStatusList();
    await this.getClaimOptions();
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Claim" }]);
    this.selectedRows = [];
    this.$nextTick(() => {
      this.isInitializing = false;
    });
  },

  activated() {
    this.selectedRows = [];
  },

  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);
    _this.status = _this.$route.query.status || _this.status;
    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
    _this.queryParams.status = _this.status;
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
